export const DYNAMIC_CONTENT = "DYNAMIC_CONTENT";
export const LOADING_CONTENT = "LOADING_CONTENT";
export const CLEAN_STORE = "CLEAN_STORE";
export const SHOW_BANNER = "SHOW_BANNER";
export const DYNAMIC_CONTENT_TYP = "DYNAMIC_CONTENT_TYP";
